module.exports = __webpack_public_path__ + "img/icon_language.f16b620e.svg";